<div class="card">
    <div class="card-body card-header-border">
        <p *ngIf="!gridData.rows.length">
            {{ _i18n._11087_NO_METRICTS_TO_DISPLAY | translate }}
        </p>
        <reusable-grid
            *ngIf="gridData.rows.length > 0"
            [rendererOptions]="gridData.rendererOpts"
            [selectTemplate]="_selectTpl"
            [rowsTop]="gridData.gridRowsTop"
            [rows]="gridData.rows"
            [sortDefs]="gridData.sortDefs"
            (selectRow)="_selectRow($event)"
            selectType="single"
            #grid
        >
            <ng-template
                gridContent
                data-type="grid"
            >
                <div></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="row"
                data-id="header"
            >
                <div></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="row"
                data-id="content"
            >
                <div></div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                data-id="header"
                let-c="c"
            >
                <div [ngSwitch]="c.id">
                    <div *ngSwitchCase="_ColumnID.METRIC">
                        {{ _i18n._713_METRIC | translate }}
                    </div>
                    <div *ngSwitchCase="_ColumnID.OA">
                        <reusable-grid-sort
                            [gridSortDef]="_getSortDef(c.id)"
                            [column]="c"
                            [isSorting]="true"
                            (sortClick)="sortMetricGrid.emit($event)"
                        >
                            {{ _i18n._7463_OA | translate }}
                        </reusable-grid-sort>
                    </div>
                    <div *ngSwitchCase="_ColumnID.ON_SCORECARD">
                        <reusable-grid-sort
                            [gridSortDef]="_getSortDef(c.id)"
                            [column]="c"
                            [isSorting]="true"
                            (sortClick)="sortMetricGrid.emit($event)"
                        >
                            {{ _i18n._9617_ON_SCORECARD | translate }}
                        </reusable-grid-sort>
                    </div>
                    <div *ngSwitchCase="_ColumnID.ACTUAL">
                        {{ _i18n._725_ACTUAL | translate }}
                    </div>
                    <div *ngSwitchCase="_ColumnID.TARGET">
                        {{ _i18n._726_TARGET | translate }}
                    </div>
                    <div *ngSwitchCase="_ColumnID.PERCENT_TO_TARGET">
                        <reusable-grid-sort
                            [gridSortDef]="_getSortDef(c.id)"
                            [column]="c"
                            [isSorting]="true"
                            (sortClick)="sortMetricGrid.emit($event)"
                        >
                            {{ _i18n._768___TO_TARGET | translate }}
                        </reusable-grid-sort>
                    </div>
                    <div *ngSwitchCase="_ColumnID.SUPERGROUP_PERCENT_TO_TARGET">
                        {{ _i18n._11084_SUPERGROUP_TO_TARGET | translate }}
                    </div>
                </div>
            </ng-template>

            <ng-template
                gridContent
                data-type="cell"
                data-id="content"
                let-c="c"
                let-l="l"
                let-ctx="ctx"
            >
                <div
                    [ngSwitch]="c.id"
                    [class.row-checked]="ctx.checked"
                    (click)="ctx.clickRow()"
                >
                    <div
                        *ngSwitchCase="_ColumnID.METRIC"
                        class="cgtsst-grid-other"
                    >
                        <cmps-checkbox
                            [variant]="ctx.checkboxVariant"
                            [checked]="ctx.checked"
                        >
                            <reusable-grid-text
                                [text]="ctx.name"
                                [resizeSubject]="ctx.resizeSubject"
                            ></reusable-grid-text>
                        </cmps-checkbox>
                    </div>
                    <div
                        *ngSwitchCase="_ColumnID.OA"
                        class="cgtsst-grid-other"
                    >
                        <cmps-icon
                            [class.cgtsst-non-opportunity]="
                                ctx.coachTypeId ===
                                _CoachingType.NON_OPPORTUNITY
                            "
                            [class.cgtsst-coached]="
                                ctx.coachTypeId === _CoachingType.COACHED
                            "
                            [class.cgtsst-uncoached]="
                                ctx.coachTypeId === _CoachingType.UNCOACHED
                            "
                            svgIcon="alert-circle"
                            [cmpsTooltipTrigger]="
                                _getCoachableTranslationText(ctx.coachTypeId)
                            "
                            trigger="hover"
                            *ngIf="ctx.coachTypeId != null"
                        ></cmps-icon>
                    </div>
                    <div
                        *ngSwitchCase="_ColumnID.ON_SCORECARD"
                        class="cgtsst-grid-other"
                    >
                        <cmps-icon
                            [cmpsTooltipTrigger]="
                                (ctx.isInScorecard
                                    ? _i18n._11091_METRIC_IS_CONFIGURED_ON_PERFORMER_S_SCORECARD
                                    : ''
                                ) | translate
                            "
                            trigger="hover"
                            class="cgtsst-on-scorecard"
                            svgIcon="check-circle"
                            *ngIf="ctx.isInScorecard"
                        ></cmps-icon>
                    </div>
                    <div
                        *ngSwitchCase="_ColumnID.ACTUAL"
                        class="cgtsst-grid-other"
                    >
                        <reusable-grid-text
                            class="text-center"
                            [text]="ctx?.actual | cmpsNumber: '1.2-2'"
                            [resizeSubject]="ctx.resizeSubject"
                        ></reusable-grid-text>
                    </div>
                    <div
                        *ngSwitchCase="_ColumnID.TARGET"
                        class="cgtsst-grid-other"
                    >
                        <reusable-grid-text
                            class="text-center"
                            [text]="ctx?.target | cmpsNumber: '1.2-2'"
                            [resizeSubject]="ctx.resizeSubject"
                        ></reusable-grid-text>
                    </div>
                    <div
                        *ngSwitchCase="_ColumnID.PERCENT_TO_TARGET"
                        class="cgtsst-grid-other"
                    >
                        <reusable-grid-text
                            class="text-center"
                            [style.color]="ctx.targetThresholdColor"
                            [text]="ctx?.percentToTarget | cmpsPercent: '1.0-2'"
                            [resizeSubject]="ctx.resizeSubject"
                        ></reusable-grid-text>
                    </div>
                    <div
                        *ngSwitchCase="_ColumnID.SUPERGROUP_PERCENT_TO_TARGET"
                        class="cgtsst-grid-other"
                    >
                        <reusable-grid-text
                            class="text-center"
                            [style.color]="ctx.superGroupTargetThresholdColor"
                            [text]="
                                ctx?.superGroupPercentToTarget
                                    | cmpsPercent: '1.0-2'
                            "
                            [resizeSubject]="ctx.resizeSubject"
                        ></reusable-grid-text>
                    </div>
                </div>
            </ng-template>
        </reusable-grid>
        <div
            class="card metric-confirmation p-2"
            *ngIf="gridData.rows.length > 0"
        >
            <div class="col-xl-5 row selected-metric">
                <span>{{ _i18n._11058_SELECTED_METRIC | translate }}</span>
                <span class="metric-label-content">{{
                    _selectedMetric?.name ?? ''
                }}</span>
            </div>
            <div class="col-xl-7 d-flex justify-content-between metric-data">
                <span>
                    {{ _i18n._725_ACTUAL | translate }}=
                    <span>{{
                        _selectedMetric?.actual | cmpsNumber: '1.2-2'
                    }}</span>
                </span>
                <span>
                    {{ _i18n._726_TARGET | translate }}=
                    <span>{{
                        _selectedMetric?.target | cmpsNumber: '1.2-2'
                    }}</span>
                </span>
                <span>
                    {{ _i18n._768___TO_TARGET | translate }}=
                    <span>{{
                        _selectedMetric?.percentToTarget | cmpsPercent: '1.0-2'
                    }}</span>
                </span>
                <span>
                    {{ _i18n._11084_SUPERGROUP_TO_TARGET | translate }}=
                    <span>{{
                        _selectedMetric?.superGroupPercentToTarget
                            | cmpsPercent: '1.0-2'
                    }}</span>
                </span>
            </div>
        </div>
    </div>
    <div
        class="card-footer card-footer-search"
        *ngIf="gridData.rows.length > 0"
    >
        <!-- TODO: implement metric confirmation -->
        <button
            cmpsButton
            (click)="_selectMetric(_selectedMetric?.id)"
            [disabled]="!_selectedMetric?.id"
        >
            <span cmpsButtonLabel>
                {{ _i18n._11085_SELECT_METRIC | translate }}
            </span>
        </button>
        <button
            cmpsButton
            class="continue-without-selection-button"
            (click)="_selectMetric(undefined)"
        >
            <span cmpsButtonLabel>
                {{ _i18n._11086_CONTINUE_WITHOUT_CONFIRM_METRIC | translate }}
            </span>
        </button>
        <ng-select
            [options]="_metrices"
            [ngModel]="_selectedMetric?.id ?? ''"
            (ngModelChange)="_selectMetric($event)"
            [placeholder]="_i18n._11083_METRIC_PLACEHOLDER_ | translate"
            forceDropdownPosition
        >
        </ng-select>
    </div>
</div>
